import Actions from "../actions";
import { produce } from "immer";

const initialState = {
  pushNotifications: {},
  sentPushNotifications: {}
};

const pushNotification = produce((draft = initialState, action) => {
  const { payload } = action;
  switch (action.type) {
    case Actions.GET_PUSH_NOTIFICATION_LIST: {
      draft.pushNotifications = payload?.pushNotifications;
      break;
    }

    case Actions.GET_SENT_PUSH_NOTIFICATION_LIST: {
      draft.sentPushNotifications = payload?.sentPushNotifications;
      break;
    }

    default: {
      break;
    }
  }
}, initialState);

export default pushNotification;
